// Eskom PARCC — Transactions filter bar (presentational).
//
// The monolith's `.filters` row above the register: Dataset, Year, Division,
// Period, Compliance selects plus a free-text search. Option lists are supplied
// by the page (enum sets unioned with the distinct values actually present), so
// this component is purely controlled — it holds no state and does no derivation.
import { FilterBar, SelectFilter, SearchInput, Button } from '../../components/ui';
import type { TransactionFilters as Filters } from './filterTransactions';

export function TransactionFilters({
  filters,
  onChange,
  onReset,
  datasetOptions,
  yearOptions,
  divisionOptions,
  periodOptions,
  complianceOptions,
}: {
  filters: Filters;
  onChange: (patch: Partial<Filters>) => void;
  onReset: () => void;
  datasetOptions: readonly string[];
  yearOptions: readonly string[];
  divisionOptions: readonly string[];
  periodOptions: readonly string[];
  complianceOptions: readonly string[];
}): React.JSX.Element {
  return (
    <div className="filters">
      <FilterBar>
        <SelectFilter
          label="Dataset"
          value={filters.dataset}
          options={withAll(datasetOptions, 'All datasets')}
          onChange={(dataset) => onChange({ dataset })}
        />
        <SelectFilter
          label="Year"
          value={filters.year}
          options={withAll(yearOptions, 'All years')}
          onChange={(year) => onChange({ year })}
        />
        <SelectFilter
          label="Division"
          value={filters.division}
          options={withAll(divisionOptions, 'All divisions')}
          onChange={(division) => onChange({ division })}
        />
        <SelectFilter
          label="Period"
          value={filters.period}
          options={withAll(periodOptions, 'All periods')}
          onChange={(period) => onChange({ period })}
        />
        <SelectFilter
          label="Compliance"
          value={filters.compliance}
          options={withAll(complianceOptions, 'All compliance levels')}
          onChange={(compliance) => onChange({ compliance })}
        />
        <SearchInput
          label="Search"
          value={filters.search}
          placeholder="Ref, supplier, division, mechanism…"
          onChange={(search) => onChange({ search })}
        />
      </FilterBar>
      <Button variant="ghost" onClick={onReset}>
        Reset filters
      </Button>
    </div>
  );
}

/** Prepend an "all" sentinel (empty value) to a value list for a select. */
function withAll(values: readonly string[], allLabel: string) {
  return [{ value: '', label: allLabel }, ...values.map((v) => ({ value: v, label: v }))];
}
